import AppProviders from '@/components/AppProviders'
import { ColorEnum } from '@/constants/color'
import Constants from 'expo-constants'
import { Slot, SplashScreen } from 'expo-router'
import { FC } from 'react'
import { SystemBars } from 'react-native-edge-to-edge'
import { GestureHandlerRootView } from 'react-native-gesture-handler'

export { RootLayoutErrorBoundary as ErrorBoundary } from '@/error-boundaries'

const Layout: FC = () => {
    return (
        <AppProviders>
            <GestureHandlerRootView
                style={{
                    flex: 1,
                    backgroundColor:
                        ColorEnum.JET_800 /* prevent white screen flickering when changing screen */,
                }}
            >
                <SystemBars style="light" />
                <Slot />
            </GestureHandlerRootView>
        </AppProviders>
    )
}

let AppEntry = Layout

if (Constants.expoConfig?.extra?.storybookEnabled) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    AppEntry = require('@/storybook/index').default
} else {
    SplashScreen.preventAutoHideAsync()
}

export default AppEntry
